import {useEffect, useRef} from 'react';
import {FORMAT_ELEMENT_COMMAND} from 'lexical';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {noop} from '@priority-software/priority-style-react';
import {isMacOS} from '../../../utils/platform';

const isMAC = isMacOS();

export const DirectionPlugin = () => {
    const [editor] = useLexicalComposerContext();
    const isMounted = useRef(false);

    useEffect(() => {
        if (isMounted.current) return noop;
        isMounted.current = true;

        return editor.registerRootListener((rootElement, prevRootElement) => {
            function handleDirectionAlignment(event: KeyboardEvent) {
                if (event.isComposing || event.keyCode === 229) return;

                const ctrlKey = isMAC ? event.metaKey : event.ctrlKey;

                if (
                    (ctrlKey && event.code === 'ShiftRight') ||
                    (event.shiftKey && event.code === 'ControlRight')
                ) {
                    editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right');
                } else if (
                    (ctrlKey && event.code === 'ShiftLeft') ||
                    (event.shiftKey && event.code === 'ControlLeft')
                ) {
                    editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left');
                }
            }

            // setup event listener
            rootElement?.addEventListener('keydown', handleDirectionAlignment);
            // remove event listener
            prevRootElement?.removeEventListener('keydown', handleDirectionAlignment);
        });
    }, [editor]);
    return null;
};
